<template>
<div>

    <b>Payment methods</b>

    <p
        style="margin-top: 15px"
    >
        Please select the payment methods that you accept below.  For your convenience, we have pre-selected the most popular payment methods.
    </p>

    <v-checkbox
        label="Visa"  
        v-model="setup_data.accept_visa" 
        v-on:change="doUpdate"
        style="margin-bottom: -25px"
    />

    <v-checkbox
        label="Mastercard"  
        v-model="setup_data.accept_mastercard" 
        v-on:change="doUpdate"
        style="margin-bottom: -25px"
    />

    <v-checkbox
        label="American Express"  
        v-model="setup_data.accept_amex" 
        v-on:change="doUpdate"
        style="margin-bottom: -25px"
    />

     <v-checkbox
        label="Discover"  
        v-model="setup_data.accept_discover" 
        v-on:change="doUpdate"
        style="margin-bottom: -25px"
    />

    <v-checkbox
        label="ACH (eCheck)"  
        v-model="setup_data.accept_ach" 
        v-on:change="doUpdate"
    />

    <div
        style="margin-top: 15px"
    />


    <b id="preferred-local-area-codes">Preferred Local Area Code(s)</b>

    <p
        style="margin-top: 15px"
    >
        Please provide a list of your local area codes (in order of your preference).  We will use these preferences when purchasing phone numbers for you. (if required).  You can add additional area codes using the (+) button.
    </p>

    <v-row>
        <v-col
            v-for="(item, index) in setup_data.area_codes"
            :key="`ac_${item}`"
            cols="auto"
            v-on:input="update"
        >
            <v-text-field
                v-model="setup_data.area_codes[index]"
                append-icon="mdi-delete"
                aria-labelledby="preferred-local-area-codes"
                v-on:click:append="onClickDeleteAreaCode(index)"
            />
        </v-col>
    </v-row>

    <m-icon-bar
        v-on:add="onClickAddAreaCode()"
        style="margin-bottom: 15px"
    />

    <b>Daily texting schedule</b>

     <p
        style="margin-top: 15px"
    >
        The times that your team will (generally) be available to text.
    </p>

    <m-daily-schedule
        v-model="setup_data.texting_schedule"
        :read_only="false"
        v-on:input="update"
    />


    <v-switch
        label="This section is complete"
        v-model="setup_data.complete"
        v-on:change="doUpdate"
    />
   
</div>
</template>

<script>
import mIconBar from '../../components/input/m-icon-bar.vue';
const _ = require('lodash');

export default 
{
  components: { mIconBar },
    props: {
        profile: {
            type: Object,
            default: function() { return {}; },
        },
    },

    data() {
        return {
            setup_data: {},
        }
    },

    mounted () {
        this.setup_data = _.cloneDeep(this.profile.general_organization_setup_data);

        if ( this.setup_data.area_codes.length == 0 )
        {
            this.setup_data.area_codes.push("");
        } 
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/welcome/general-organization-setup-data',
            
                'params' : this.setup_data,
            
                'on_success': (data) => {
                       
                        this.$emit('reload');
                        
                    },
            
                'on_error': 'Unable to save form data',
            });
        },
        
        onClickDeleteAreaCode(index)
        {
            this.setup_data.area_codes.splice(index,1);
            this.doUpdate();
        },

        onClickAddAreaCode()
        {
            this.setup_data.area_codes.push("");
        },
    },
}
</script>

<style lang="scss" scoped>

</style>

